import { ComposeFeatures } from '../core/hub-types';

export type Trigger = '@' | '#' | '/';

/** The chips over the focused message field that type @, # or /, for what this conversation takes. */
export function triggerChips(features: ComposeFeatures, actions = false): { trigger: Trigger; label: string }[] {
  const out: { trigger: Trigger; label: string }[] = [];
  if (features.people) out.push({ trigger: '@', label: 'Colleague' });
  if (features.patients) out.push({ trigger: '#', label: 'Patient' });
  if (actions) out.push({ trigger: '/', label: 'Action' });
  return out;
}

/** The line in an @, # or / picker with nothing to list: what to type while only the trigger is there, else no match. */
export function emptyPickerHint(trigger: Trigger, query: string): string {
  if (trigger === '/') return query.trim() ? 'No action by that name' : 'Type an action';
  if (!query.trim()) return trigger === '#' ? "Type a patient's name or number" : "Type a colleague's name";
  return trigger === '#' ? 'No patient by that name or number' : 'No one here by that name';
}
